import { Form, Row, Col, Input, DatePicker, TimePicker } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { DATE_FORMAT_FORM } from 'utils/date';
import '../../../../Formulario.scss';
import { CONFIGURACION_SISTEMA } from 'constants/nombresCatalogos';
import * as fieldMsgs from 'constants/formFieldsMessages';
import dayjs from 'dayjs';

const placement = 'topRight';

const DatosInicioVisita = ({ form }) => {
  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const fechaIniciOper =
    configuracionSistema.find((config) => config?.parametro === 'FECHA_INICIO_OPERACIONES')
      ?.valor || null;
  const dateFormat = 'YYYYMMDD';
  const fechaHoy = new Date().toISOString().slice(0, 10);

  return (
    <div>
      <Form form={form} layout="vertical">
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={4}>
            <Form.Item
              name="ordenVisita"
              label="No. de orden de visita:"
              rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
              {/* <SimpleNumericInput placeholder="No. de orden de visita" maxLength={10} /> */}
              <Input placeholder="No. de orden de visita" maxLength={30} />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              name="fechaApertura"
              label="Fecha de apertura:"
              rules={[{ required: true, message: fieldMsgs.ERR_DATE_FIELD_REQUIRED }]}>
              <DatePicker
                minDate={dayjs(fechaIniciOper, dateFormat)}
                maxDate={dayjs(fechaHoy, dateFormat)}
                placement={placement}
                placeholder="Selecciona..."
                format={DATE_FORMAT_FORM}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Hora de apertura:" className="style-copy-form-item">
              <div className="reloj-campo">
                <Form.Item
                  className="personal-form-item-hora"
                  name="horaApertura"
                  rules={[{ required: true, message: fieldMsgs.ERR_TIME_FIELD_REQUIRED }]}>
                  <TimePicker placeholder="00:00" />
                </Form.Item>
                <p className="style-p-hrs">hrs.</p>
              </div>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              name="fechaCierre"
              label="Fecha de cierre:"
              rules={[{ required: true, message: fieldMsgs.ERR_DATE_FIELD_REQUIRED }]}>
              <DatePicker
                minDate={dayjs(fechaIniciOper, dateFormat)}
                maxDate={dayjs(fechaHoy, dateFormat)}
                placement={placement}
                placeholder="Selecciona..."
                format={DATE_FORMAT_FORM}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Hora de cierre:" className="style-copy-form-item">
              <div className="reloj-campo">
                <Form.Item
                  className="personal-form-item-hora"
                  name="horaCierre"
                  rules={[{ required: true, message: fieldMsgs.ERR_TIME_FIELD_REQUIRED }]}>
                  <TimePicker placeholder="00:00" />
                </Form.Item>
                <p className="style-p-hrs">hrs.</p>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

DatosInicioVisita.propTypes = {
  form: PropTypes.shape({}).isRequired
};

export default DatosInicioVisita;
